var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgIconTickerTape = function SvgIconTickerTape(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8 8C-8 5.79086 -6.20914 4 -4 4H0C2.20914 4 4 5.79086 4 8V16C4 18.2091 2.20914 20 0 20H-4C-6.20914 20 -8 18.2091 -8 16V8ZM-4 6C-5.10457 6 -6 6.89543 -6 8V16C-6 17.1046 -5.10457 18 -4 18H0C1.10457 18 2 17.1046 2 16V8C2 6.89543 1.10457 6 0 6H-4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8C6 5.79086 7.79086 4 10 4H14C16.2091 4 18 5.79086 18 8V16C18 18.2091 16.2091 20 14 20H10C7.79086 20 6 18.2091 6 16V8ZM10 6C8.89543 6 8 6.89543 8 8V16C8 17.1046 8.89543 18 10 18H14C15.1046 18 16 17.1046 16 16V8C16 6.89543 15.1046 6 14 6H10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4C21.7909 4 20 5.79086 20 8V16C20 18.2091 21.7909 20 24 20H28C30.2091 20 32 18.2091 32 16V8C32 5.79086 30.2091 4 28 4H24ZM22 8C22 6.89543 22.8954 6 24 6H28C29.1046 6 30 6.89543 30 8V16C30 17.1046 29.1046 18 28 18H24C22.8954 18 22 17.1046 22 16V8Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTickerTape, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_ticker-tape.d8c51531.svg";
export { ForwardRef as ReactComponent };